import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  CURRENT_PAGE_KEY,
  CURRENT_REGION_KEY,
  SEARCH_TERM_KEY,
} from "../data/constants";
import { Box, Container, Flex, Typography } from "../shared/index";
import { Moon } from "./icons";

interface AppBarProps {
  handleThemeToggle: () => void;
  onHomeReset: () => void;
}

const AppBar: React.FC<AppBarProps> = ({ handleThemeToggle, onHomeReset }) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    localStorage.removeItem(SEARCH_TERM_KEY);
    localStorage.removeItem(CURRENT_REGION_KEY);
    localStorage.removeItem(CURRENT_PAGE_KEY);
    onHomeReset();
    navigate("/");
  };

  return (
    <Box
      css={{
        height: "$8",
        boxShadow: "$2",
        bgcolor: "$primary",
        borderRadius: "none",
        color: "$secondary",
      }}
    >
      <Container>
        <Flex
          css={{
            height: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            as="h1"
            css={{
              fontWeight: "$bold",
              cursor: "pointer",
              "@bp2": {
                fontSize: "$3",
              },
              "@bp3": {
                fontSize: "$4",
              },
            }}
            onClick={handleHomeClick}
          >
            Where in the world?
          </Typography>
          <Flex
            css={{ alignItems: "center", cursor: "pointer" }}
            onClick={handleThemeToggle}
          >
            <Moon />
            <Typography as="h1" css={{ color: "$light" }}>
              Dark Mode
            </Typography>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default AppBar;
